import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./Components/Routes/Routes";
import { useAutoPageTracing } from "./hooks/useAutoPageTracing";

const AppContent: React.FC<{ msalInstance: any }> = ({ msalInstance }) => {
 
  useAutoPageTracing();
  return <AppRoutes msalInstance={msalInstance} />;
};

const App: React.FC<{ msalInstance: any }> = ({ ...props }) => {
  return (
    <Router>
       <AppContent msalInstance={props.msalInstance} />
    </Router>
  );
};

export default App;
